define('models/PendingEvaluations',[
    'lib/knockout',
    'util/ObservableModel'
], function (ko, ObservableModel) {
    'use strict';

    var PendingEvaluations = ObservableModel.extend({}, function () {});

    return PendingEvaluations;
});

